import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
      return (
      <header>

        <div className="header-top">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 col-xs-6 header-top-left">
                <ul className="list-unstyled">
                <li><i className="fa fa-envelope"></i> dbp@flacso.org.ar</li>
                  <li><i className="fa fa-phone"></i> +(5411) 5238 9459</li>
                </ul>
              </div>
              <div className="col-sm-6 col-xs-6 header-top-right">
                <ul className="list-unstyled">
                  <li>Seguinos en:</li>
                  <li><a href="https://www.linkedin.com/in/programa-de-derecho-y-bienes-p%C3%BAblicos-90a3b3161/"><i className="fa fa-linkedin"></i></a></li>
                  <li><a href="https://www.instagram.com/dbpflacso/"><i className="fa fa-instagram"></i></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
          <div className="main-menu">
          <div className="container">
            <div className="row">

              <div className="col-sm-12">
                <nav className="navbar" id="main-nav">

                  <div className="container">
                    <div className="navbar-header">
                      <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#edulight-navbar-collapse" aria-expanded="false" style={{marginTop: "27px", marginBottom: "0px", marginRight: "0px"}}>
                        <span className="sr-only">Toggle navigation</span>
                        <span className="icon-bar flacso-verde-fondo"></span>
                        <span className="icon-bar flacso-verde-fondo"></span>
                        <span className="icon-bar flacso-verde-fondo"></span>
                      </button>
                      <Link className="navbar-brand" to="/"><img src="/images/logo_flacso.png" alt="Flacso" style={{marginTop:-9}}/></Link>
                    </div>

                    <div className="nav-container flacso-azul">
                      <div className="collapse navbar-collapse" id="edulight-navbar-collapse">
                        <ul className="nav navbar-nav" onClick={e=>document.querySelector('button[aria-expanded=true]')?document.querySelector('button[aria-expanded=true]').click():null}>
                          <li><Link to="/quienes-somos">QUIéNES SOMOS</Link></li>
                          <li><Link to="/actualidad">ACTUALIDAD</Link></li>
                          <li><Link to="/publicaciones">PUBLICACIONES</Link></li>
                          <li><Link to="/catedra-omc">CÁTEDRA OMC</Link></li>
                          <li><Link to="/propiedad-intelectual">PROPIEDAD INTELECTUAL</Link></li>
                          <li><Link to="/agenda">AGENDA</Link></li>
                          <li><Link to="/multimedia">MULTIMEDIA</Link></li>
                        </ul>
                      </div>
                    </div>
                  </div>

                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>
    )
}

export default Header;
